import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ContestsInterestedIn } from './contests-interested-in.model';

export interface GenerateContestsInterestedInOptions {
  readonly id?: number;
  readonly relatedContestId: number;
  readonly prizeInUSD?: number;
  readonly contestName?: string;
  readonly ownerId: number;
  readonly ownerPublicName: string;
  readonly ownerUsername: string;
  readonly completed: boolean;
}

export function generateContestsInterestedInObject({
  id = generateId(),
  relatedContestId,
  prizeInUSD = 100,
  contestName = 'Test Contest',
  ownerId,
  ownerPublicName,
  ownerUsername,
  completed,
}: GenerateContestsInterestedInOptions): ContestsInterestedIn {
  return {
    id,
    relatedContestId,
    prizeInUSD,
    contestName,
    ownerId,
    ownerPublicName,
    ownerUsername,
    completed,
  };
}
